import { render, staticRenderFns } from "./TransportOrderMultiDetail.vue?vue&type=template&id=7fc24b46&scoped=true"
import script from "./TransportOrderMultiDetail.vue?vue&type=script&lang=js"
export * from "./TransportOrderMultiDetail.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderMultiDetail.vue?vue&type=style&index=0&id=7fc24b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc24b46",
  null
  
)

export default component.exports